function cov_1q6mdd6drm() {
  var path = "/app/src/utils/get-longest-subvention-plan.ts";
  var hash = "8f938be168ec336b8abe05965f04f3f524748f13";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-longest-subvention-plan.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 40
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 26
        },
        end: {
          line: 9,
          column: 3
        }
      },
      "2": {
        start: {
          line: 8,
          column: 11
        },
        end: {
          line: 8,
          column: 58
        }
      },
      "3": {
        start: {
          line: 10,
          column: 32
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "4": {
        start: {
          line: 11,
          column: 14
        },
        end: {
          line: 11,
          column: 47
        }
      },
      "5": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 40
          },
          end: {
            line: 4,
            column: 41
          }
        },
        loc: {
          start: {
            line: 6,
            column: 35
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 8,
            column: 5
          }
        },
        loc: {
          start: {
            line: 8,
            column: 11
          },
          end: {
            line: 8,
            column: 58
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        },
        loc: {
          start: {
            line: 11,
            column: 14
          },
          end: {
            line: 11,
            column: 47
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 11
          },
          end: {
            line: 8,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 11
          },
          end: {
            line: 8,
            column: 31
          }
        }, {
          start: {
            line: 8,
            column: 35
          },
          end: {
            line: 8,
            column: 58
          }
        }],
        line: 8
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8f938be168ec336b8abe05965f04f3f524748f13"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1q6mdd6drm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1q6mdd6drm();
// this function is used for supporting old subvention campaigns (with isLimitedTimeOffer but without subventionCampaignId)
cov_1q6mdd6drm().s[0]++;
export var getLongestSubventionPlan = function getLongestSubventionPlan(installments) {
  cov_1q6mdd6drm().f[0]++;
  var subventionPlans = (cov_1q6mdd6drm().s[1]++, installments.filter(function (f) {
    cov_1q6mdd6drm().f[1]++;
    cov_1q6mdd6drm().s[2]++;
    return (cov_1q6mdd6drm().b[0][0]++, f.isLimitedTimeOffer) && (cov_1q6mdd6drm().b[0][1]++, !f.subventionCampaignId);
  }));
  var sortedSubventionPlans = (cov_1q6mdd6drm().s[3]++, subventionPlans.sort(function (a, b) {
    cov_1q6mdd6drm().f[2]++;
    cov_1q6mdd6drm().s[4]++;
    return b.paymentsCount - a.paymentsCount;
  }));
  cov_1q6mdd6drm().s[5]++;
  return sortedSubventionPlans[0];
};